import { lazy } from "react";

const Dashboard = lazy(() => import("../pages/Home"));

// const Tables = lazy(() =>
//   import('../pages/Tables')
// );

const UserProfile = lazy(() => import("../pages/Account/UserProfile"));

const AddCompany = lazy(() => import("../pages/Companies/AddCompany"));

const EditCompany = lazy(() => import("../pages/Companies/EditCompany"));

const Roles = lazy(() => import("../pages/Roles"));
const AddRole = lazy(() => import("../pages/Roles/AddRole"));

const EditRole = lazy(() => import("../pages/Roles/EditRole"));

const Deals = lazy(() => import("../pages/Deals"));

const ViewDeal = lazy(() => import("../pages/Deals/ViewDeal"));

const LeadsTable = lazy(() => import("../pages/Leads/LeadTables"));

const CreateLead = lazy(() => import("../pages/Leads/CreateLead"));
const ViewLead = lazy(() => import("../pages/Leads/ViewLead"));

const EditLead = lazy(() => import("../pages/Leads/EditLead"));

const UnsyncLeads = lazy(() => import("../pages/Leads/UnsyncLeads"));

const Users = lazy(() => import("../pages/Users"));
const AddUser = lazy(() => import("../pages/Users/AddUser"));
const EditUser = lazy(() => import("../pages/Users/EditUser"));

const Companies = lazy(() => import("../pages/Companies"));

const Reports = lazy(() => import("../pages/Reports"));

const ActivityLogs = lazy(() => import("../pages/ActivityLogs"));

const Settings = lazy(() => import("../pages/Settings"));

const SearchResultPage = lazy(() => import("../pages/Settings/SearchPage"));

const UserNotification = lazy(() =>
  import("../pages/Settings/UserNotification")
);

const ECPLeadView = lazy(() => import("../pages/Leads/Ecp_lead_view"));

const UserDocuments = lazy(() => import("../pages/Users/UserDocuments"));

const defaultTitle = "Clients & Partners Portal - The Lending Tree";

//For permissions, simply remove permissionId if you want to show it regardless of permission status

const routes = [
  {
    path: "/dashboard",
    exact: true,
    name: "Dashboard",
    title: "Dashboard - " + defaultTitle,
    component: Dashboard,
    // permissionId: 'dashboard' //TODO: decide if dashboard should be outsted
  },
  {
    path: "/leads",
    exact: true,
    name: "Leads List",
    title: "Leads - " + defaultTitle,
    component: LeadsTable,
    permissionId: "leads",
  },
  {
    path: "/leads/create",
    exact: true,
    name: "Create Lead Details",
    title: "Create Lead details - " + defaultTitle,
    component: CreateLead,
    // permissionId: 'leads-add'
  },
  {
    path: "/cases",
    exact: true,
    name: "Cases List",
    title: "Cases - " + defaultTitle,
    component: Deals,
    permissionId: "deals",
  },
  {
    path: "/unsyncleads",
    exact: true,
    name: "Unsync Leads List",
    title: "Unsync Leads - " + defaultTitle,
    component: UnsyncLeads,
    permissionId: "unsyncleads",
  },
  {
    path: "/activitylogs",
    exact: true,
    name: "Activity Logs List",
    title: "Activity Logs - " + defaultTitle,
    component: ActivityLogs,
    permissionId: "activitylogs",
  },
  {
    path: "/reports",
    exact: true,
    name: "Reports",
    title: "Reports - " + defaultTitle,
    component: Reports,
    permissionId: "reports",
  },
  {
    path: "/roles",
    exact: true,
    name: "Roles & Permission",
    title: "Roles - " + defaultTitle,
    component: Roles,
    permissionId: "roles",
  },
  {
    path: "/leads/view/:id",
    exact: true,
    name: "Lead Details",
    title: "Lead details - " + defaultTitle,
    component: ViewLead,
    permissionId: "leads-view",
  },
  {
    path: "/leads/view/:id/:scope",
    exact: true,
    name: "Lead Details",
    title: "Lead details - " + defaultTitle,
    component: ViewLead,
    permissionId: "leads-view",
  },
  {
    path: "/leads/ECPLeadView/:id",
    exact: true,
    name: "Lead Details",
    title: "Lead details - " + defaultTitle,
    component: ECPLeadView,
    permissionId: "leads-view",
  },
  {
    path: "/users",
    exact: true,
    name: "Users List",
    title: "Users - " + defaultTitle,
    component: Users,
    permissionId: "users",
  },
  {
    path: "/users/user-documents",
    exact: true,
    name: "Users Documents",
    title: "User Documents - " + defaultTitle,
    component: UserDocuments,
    permissionId: "users",
  },
  {
    path: "/companies",
    exact: true,
    name: "Company List",
    title: "Companies - " + defaultTitle,
    component: Companies,
    permissionId: "companies",
  },
  {
    path: "/settings",
    exact: true,
    name: "Settings",
    title: "Settings - " + defaultTitle,
    component: Settings,
  },
  {
    path: "/search/search-result/:id",
    exact: true,
    name: "Search Result",
    title: "Settings - " + defaultTitle,
    component: SearchResultPage,
  },
  {
    path: "/notifications",
    exact: true,
    name: "User Notification",
    title: "Notification - " + defaultTitle,
    component: UserNotification,
  },
  {
    path: "/profile",
    exact: true,
    name: "Profile",
    title: "User Profile - " + defaultTitle,
    component: UserProfile,
  },
  {
    path: "/profile/:scope",
    exact: true,
    name: "Profile",
    title: "User Profile - " + defaultTitle,
    component: UserProfile,
  },
  {
    path: "/leads/edit/:id",
    exact: true,
    name: "Edit Lead Details",
    title: "Edit Lead details - " + defaultTitle,
    component: EditLead,
    // permissionId: 'leads-edit'
  },
  {
    path: "/cases/view/:id",
    exact: true,
    name: "View Case Details",
    title: "View Case details - " + defaultTitle,
    component: ViewDeal,
    // permissionId: 'leads-edit'
  },
  {
    path: "/cases/view/:id/:scope",
    exact: true,
    name: "View Case Details",
    title: "View Case details - " + defaultTitle,
    component: ViewDeal,
    // permissionId: 'leads-edit'
  },
  {
    path: "/users/add",
    exact: true,
    name: "Add Users",
    title: "Add Users - " + defaultTitle,
    component: AddUser,
    // permissionId: 'users-add'
  },
  {
    path: "/users/edit/:id",
    exact: true,
    name: "Edit Users",
    title: "Edit Users - " + defaultTitle,
    component: EditUser,
    // permissionId: 'users-edit'
  },
  {
    path: "/roles/add",
    exact: true,
    name: "Add Roles & Permission",
    title: "Add Role - " + defaultTitle,
    component: AddRole,
    permissionId: "roles-add",
  },
  {
    path: "/roles/edit/:id",
    exact: true,
    name: "Edit Roles & Permission",
    title: "Edit Role - " + defaultTitle,
    component: EditRole,
    permissionId: "roles-view",
  },

  {
    path: "/companies/add",
    exact: true,
    name: "Add Companies",
    title: "Companies add - " + defaultTitle,
    component: AddCompany,
    permissionId: "companies-add",
  },
  {
    path: "/companies/edit/:id",
    exact: true,
    name: "Edit Company Details",
    title: "Companies Edit - " + defaultTitle,
    component: EditCompany,
    permissionId: "companies-edit",
  },
];

export default routes;
